import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { NoticeReadLogParam } from "features/stock-ordering/core/stock-ordering.params";
import {
  PostNoticeReadLogRepository,
  PostNoticeReadLogResponse,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum PostNoticeReadLogState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: PostNoticeReadLogState;
  message: string;
}

const initialState: InitialState = {
  status: PostNoticeReadLogState.initial,
  message: "",
};

export const postNoticeReadLog = createAsyncThunk(
  "postNoticeReadLog",
  async (param: NoticeReadLogParam, { rejectWithValue }) => {
    try {
      const response: PostNoticeReadLogResponse =
        await PostNoticeReadLogRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

export const postNoticeReadLogSlice = createSlice({
  name: "postNoticeReadLog",
  initialState,
  reducers: {
    resetPostNoticeReadLog: (state) => {
      state.status = PostNoticeReadLogState.initial;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postNoticeReadLog.pending, (state) => {
        state.status = PostNoticeReadLogState.inProgress;
      })
      .addCase(postNoticeReadLog.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = PostNoticeReadLogState.success;
          state.message = message;
        }
      })
      .addCase(postNoticeReadLog.rejected, (state, action) => {
        state.status = PostNoticeReadLogState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectPostNoticeReadLog = (state: RootState) =>
  state.postNoticeReadLog;
export const { resetPostNoticeReadLog } = postNoticeReadLogSlice.actions;
export default postNoticeReadLogSlice.reducer;
